import { atom } from "jotai";
import { defaultSelectedPatient, notFoundPatient } from "../../../../consts";
import { PatientInfo } from "../../../../ts";
import { patientsAtom } from "./patients-atoms";
import { selectedPatientIdAtom } from "./selected-patient-atom";

export const selectedPatientBaseAtom = atom<PatientInfo>(get => {
  const patients = get(patientsAtom);
  const selectedPatientId = get(selectedPatientIdAtom);

  if (patients.length === 0 || selectedPatientId == null) return defaultSelectedPatient;

  return patients.find(patient => patient.id === selectedPatientId) || notFoundPatient;
});
